import React from 'react';
import { Redirect } from 'react-router-dom';

import { hasAnyRole } from 'utils/credentials';

const RouteGuard = ({ roles, fallback, children }) =>
  !roles || hasAnyRole(roles) ? children : <Redirect to={fallback || '/dashboard'} />;

export default RouteGuard;
